import ProductAvailabilityPrice from "./ProductAvailabilityPrice.component";

export default ProductAvailabilityPrice;
